import { useQuery } from '@tanstack/react-query';
import { useAtomValue, useSetAtom } from 'jotai';
import Breadcrumbs from '@/components/Breadcrumbs';
import useTopbar from '@hooks/useTopbar';
import {
	countAtom,
	decrementAtom,
	incrementAtom,
} from '@/store/counterAtoms';

type SampleResponse = {
	message: string;
	timestamp: string;
};

const fetchSample = async (): Promise<SampleResponse> => {
	await new Promise((resolve) => setTimeout(resolve, 300));

	return {
		message: 'hello from cs-fctg-services-authorization-frontend',
		timestamp: new Date().toISOString(),
	};
};

const useHomePage = () => {
	const count = useAtomValue(countAtom);
	const increment = useSetAtom(incrementAtom);
	const decrement = useSetAtom(decrementAtom);

	useTopbar(<Breadcrumbs />);

	const { data: sample, isLoading: isSampleLoading } = useQuery({
		queryKey: ['sample'],
		queryFn: fetchSample,
	});

	return {
		count,
		increment,
		decrement,
		sample,
		isSampleLoading,
	};
};

export default useHomePage;
